import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'allocationStatus'
})
export class AllocationStatusPipe implements PipeTransform {

  public transform(allocation: any): any {
    const status = {
      totalConfirmed: 0,
      totalPending: 0,
      totalWaiting: 0,
      totalUnused: 0
    };

    if (allocation && allocation.length > 0) {
      if (allocation.find(x => x.type === 'success')) {
        status.totalConfirmed = allocation.find(x => x.type === 'success')?.value;
      }
      if (allocation.find(x => x.type === 'warning')) {
        status.totalPending = allocation.find(x => x.type === 'warning')?.value;
      }
      if (allocation.find(x => x.type === 'primary')) {
        status.totalWaiting = allocation.find(x => x.type === 'primary')?.value;
      }
      if (allocation.find(x => x.type === 'danger')) {
        status.totalUnused = allocation.find(x => x.type === 'danger')?.value;
      }
    }

    return status;
  }
}
